import React, { useState, useEffect, useContext } from "react";
import PlaidLink from "react-plaid-link";
import {
  RESOLVE_EVENT,
  NOTIFICATIONS_QUERY,
  PAYMENT_METHODS_QUERY
} from "utils/mutations";
import { useMutation } from "@apollo/react-hooks";
import axios from "axios";
import Loading from "components/common/Loading";
import { ServerNotificationsContext } from "components/common/wrappers/withServerNotifications";

// Welcome to Hack City

// This code is a bit messy for two reasons
// 1. There is currently a bug with react-plaid-link v2.0.3 to where the token must be present before the component loads, that's
//    why i split the two components apart
// 2. There is no simple "open" parameter to pass to a component unlike Material Ui Modals for instance. Therefore I had
//    to use the "open()" which is kinda weird in react
// 3. There is a "ready" parameter that's supposed to tell you when you can call the open() function. However the ready is actually called
//    before open() function gets updated. Therefore i have it calling "open()" multiple times but it seems to be ok because
//    the react-plaid-link package checks for that.

const UpdateAccount = ({ setErrorMessage, complete, reset, itemId, open }) => {
  const [token, setToken] = useState();
  const [environment, setEnvironment] = useState();
  const [loading, setLoading] = useState(true);
  const [plaidLoaded, setPlaidLoaded] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [resolveEvent] = useMutation(RESOLVE_EVENT);
  const { getServerNotifications } = useContext(ServerNotificationsContext);

  useEffect(() => {
    const getPublicToken = async () => {
      try {
        const publicToken = await axios.post("/accounts/publicToken", {
          itemId
        });
        setLoading(false);
        const {
          data: { token: t, is_dev, resolved, error } = {}
        } = publicToken;
        if (error) {
          console.log("Error getting public token:", error);
          return;
        }
        if (resolved) {
          getServerNotifications();
          return;
        }
        console.log("t", t);
        console.log("is_dev", is_dev);
        if (is_dev) setEnvironment("development");
        if (t) setToken(t);
      } catch (err) {
        setLoading(false);
      }
    };
    if (open) {
      getPublicToken();
    }
  }, [open, itemId, getServerNotifications]);

  useEffect(() => {
    if (token && plaidLoaded && !buttonClicked) {
      const plaidDivEl = document.getElementById("plaid-button-div");
      const plaidButtonEl = plaidDivEl.getElementsByTagName("button");
      plaidButtonEl[0].click();
      setButtonClicked(true);
    }
  }, [token, plaidLoaded, buttonClicked]);

  const onSuccess = () => {
    resolveEvent({
      variables: {
        id: itemId
      },
      refetchQueries: [
        { query: NOTIFICATIONS_QUERY },
        { query: PAYMENT_METHODS_QUERY }
      ]
    }).then(() => {
      getServerNotifications();
      complete();
      reset();
      setToken();
      setButtonClicked();
      setPlaidLoaded();
    });
  };

  const onLoad = (error, metadata) => {
    if (!plaidLoaded) setPlaidLoaded(true);
    console.log("plaid onLoad - error:", error, "metadata: ", metadata);
  };

  const onExit = (error = {}, metadata = {}) => {
    console.log("plaid onExit - error:", error, "metadata:", metadata);
    if ((error !== null ? error : {}).error_code === "item-no-error") {
      console.log(
        "PlaidLink reported that the item run in update mode is in a good state. Resolving event."
      );
      resolveEvent({
        variables: {
          id: itemId
        },
        refetchQueries: [
          { query: NOTIFICATIONS_QUERY },
          { query: PAYMENT_METHODS_QUERY }
        ],
        awaitRefetchQueries: true
      }).then(() => {
        getServerNotifications();
        complete();
        reset();
        setPlaidLoaded();
        setToken();
        setButtonClicked();
      });
    } else {
      reset();
      setPlaidLoaded();
      setToken();
      setButtonClicked();
    }
  };

  const onEvent = (eventType, metadata) => {
    console.log("plaid onEvent - type:", eventType, "metadata: ", metadata);

    if (eventType === "OPEN") {
      setErrorMessage("");
    }
    if (eventType === "ERROR" && metadata.error_code) {
      if (metadata.error_code === "NO_AUTH_ACCOUNTS") {
        setErrorMessage("No valid checking or savings account(s) found");
      } else {
        setErrorMessage(
          "Something went wrong. Please try again or contact support."
        );
      }
      console.log(
        "Plaid link reported an error: Error code",
        metadata.error_code,
        "-",
        metadata.error_message
      );
    }
    if (eventType === "HANDOFF") {
      console.log("Handoff");
    }
  };

  if (!open) return null;

  if (loading) return <Loading />;

  return token ? (
    <div id="plaid-button-div" className="hidden">
      <PlaidLink
        id="plaid-button"
        clientName="Tomo Credit"
        env={environment || process.env.REACT_APP_PLAID_ENV}
        product={["auth", "assets"]} // While we only need auth for a payment method, we want to have a fully-functional access token on file
        publicKey="f9d5c9d432e4d2c64e5b0cf80f897f" // TODO: Get value from env
        onLoad={onLoad}
        onEvent={onEvent}
        onSuccess={onSuccess}
        onExit={onExit}
        token={token}
        webhook="https://enrjdsgppce0l3p.m.pipedream.net" // TODO: Get value from env
        onClick={() => {
          // if (!isMobile) {
          //   resetSuccess();
          //   setError(false);
          // }
        }}
      >
        + add new account
      </PlaidLink>
    </div>
  ) : null;
};

export default UpdateAccount;
